module.exports = __webpack_public_path__ + "static/media/banner.3a9e12f3.png";